import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

type PaddingSize = 'none' | 'small' | 'medium' | 'large';
type Padding =
  | PaddingSize
  | { top?: PaddingSize; right?: PaddingSize; bottom?: PaddingSize; left?: PaddingSize }
  | { vertical?: PaddingSize; horizontal?: PaddingSize };

@Component({
  selector: 'container',
  imports: [MatProgressSpinnerModule],
  templateUrl: './container.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './container.component.scss',
})
export class ContainerComponent {
  @Input() public isScrollable = false;
  @Input() public verticalHeight: 'fit' | 'fill' = 'fit';
  @Input() public padding: Padding = 'none';
  @Input() public isLoading = false;

  @HostBinding('style.overflow-y') get scrollable() {
    return this.isScrollable ? 'auto' : 'hidden';
  }
  @HostBinding('style.height') get height() {
    return this.verticalHeight === 'fit' ? 'fit-content' : 'auto';
  }

  @HostBinding('style.flex') get flex() {
    return this.verticalHeight === 'fill' ? '1' : 'none';
  }

  @HostBinding('style.padding') get paddingStyle() {
    if (typeof this.padding === 'string') {
      return this.getPadding(this.padding);
    }

    if ('vertical' in this.padding || 'horizontal' in this.padding) {
      const vertical = this.getPadding(this.padding.vertical);
      const horizontal = this.getPadding(this.padding.horizontal);
      return `${vertical} ${horizontal}`;
    }

    if (
      'top' in this.padding ||
      'right' in this.padding ||
      'bottom' in this.padding ||
      'left' in this.padding
    ) {
      const top = this.getPadding(this.padding.top);
      const right = this.getPadding(this.padding.right);
      const bottom = this.getPadding(this.padding.bottom);
      const left = this.getPadding(this.padding.left);
      return `${top} ${right} ${bottom} ${left}`;
    }

    return '0';
  }

  getPadding(paddingSize: PaddingSize) {
    switch (paddingSize) {
      case 'small':
        return '0.5rem';
      case 'medium':
        return '1rem';
      case 'large':
        return '1.5rem';
      default:
        return '0';
    }
  }
}
